import type { IconData } from '@stacksjs/iconify-core'

export const functionsAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M128 416h232v-32H160v-9.717L269.834 256L160 137.717V128h200V96H128v54.283L226.166 256L128 361.717z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default functionsAlt
